import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AiTextPartVm } from '@domain/ai-assistant/ai-assistant.view-models';

import { MarkdownComponent } from '@shared/components/markdown/markdown.component';

@Component({
  selector: 'app-ai-output-part',
  imports: [MarkdownComponent],
  templateUrl: './ai-output-part.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class AiOutputPartComponent {
  public part = input.required<AiTextPartVm>();
}
